import React, { useEffect } from "react";
import Compressor from "compressorjs";
import { styled } from "@mui/material/styles";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import NativeSelect from "@mui/material/NativeSelect";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { allSlots } from "../../../features/eventDetails/updateEventSlice";
import dayjs, { Dayjs } from "dayjs";
import {
  FormControl,
  Grid,
  Button,
  InputAdornment,
  Box,
  Typography,
  TextField,
  Container,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Divider,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers";
import OutlinedInput from "@mui/material/OutlinedInput";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import "../../event/event.css";
import { useAppDispatch, useAppSelector } from "../../../helpers/hooks";
import { fetchEventCategories } from "../../../features/eventDetails/eventCategorySlice";
import { getAllDepartments } from "../../../features/eventDetails/createEventSlice";
import Toaster from "../../toaster";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import Loader from "../../loader";
import { useParams } from "react-router-dom";
import { fetchEventDetails } from "../../../features/eventDetails/eventDetailsSlice";

interface file {
  lastModified: number;
  lastModifiedDate: {};
  name: string;
  size: number;
  type: string;
}

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "visible",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

interface TimeSlot {
  startDate: any;
  endDate: any;
  startTime: any;
  endTime: any;
  allslots: string;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BoldDemoItem = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <DemoItem label={<Typography fontWeight={500}>{label}</Typography>}>
    {children}
  </DemoItem>
);

const ManageEventForm = ({
  open,
  handleClose,
  title,
  data,
  handleChange,
  submitForm,
  disablePublish,
  openToasterForm,
  isLoading,
  isEdit,
  resetForm,
}: any) => {
  const dispatch = useAppDispatch();
  const eventCategories = useAppSelector(
    (state) => state.eventCategories.eventCategories,
  );
  const departments = useAppSelector((state) => state.createEvent.department);
  // const eventDetails = useAppSelector(
  //   (state): EventDetails => state.eventDetails.details.event
  // );
  const getEvent = useAppSelector((state) => state.eventDetails.details.event);
  const location = ["Bengaluru", "Pune", "Virtual"];
  const [toastMessage, setToastMessage] = React.useState("");
  const [openToaster, setOpenToaster] = React.useState(false);
  const [imageName, setImageName] = React.useState<Array<file>>([]);
  const [idToDelete, setIdToDelete] = React.useState<any>([]);
  const [uploadedFiles, setUploadedFiles] = React.useState<File[]>([]);
  const options = [
    "Affordable And Clean Energy",
    "Clean Water And Sanitation",
    "Climate Action",
    "Decent Work And Economic Growth",
    "Gender Equality",
    "Good Health And Well-Being",
    "Industry Innovation And Infrastructure",
    "Life Below Water",
    "Life On Land",
    "No Poverty",
    "Partnerships For The Goals",
    "Peace And Justice String Institutions",
    "Quality Education",
    "Reduced Inequalities",
    "Responsible Consumption And Production",
    "Sustainable Cities And Communities",
    "Zero Hunger",
  ];
  const [timeSlots, setTimeSlots] = React.useState<TimeSlot[]>([]);
  // const eventDetails = useAppSelector(
  //   (state) => state.eventDetails.details.event
  // );
  const eventDetails = useAppSelector(
    (state): any => state.eventDetails.details.event,
  );
  const { id } = useParams();
  const [initialized, setInitialized] = React.useState(false);
  const [singleSlotCapacity, setSingleSlotCapacity] = React.useState("");

  useEffect(() => {
    if (id) {
      dispatch(fetchEventDetails(id));
    }
  }, [id]);

  // useEffect(() => {
  //   console.log("DATA UPDATED:", data);
  // }, [data]);
  // useEffect(() => {
  //   console.log("PARENT DATA:", data);
  //   console.log("TIMESLOTS STATE:", timeSlots);
  // }, [data, timeSlots]);

  // useEffect(() => {
  //   console.log("isLoading:", isLoading);
  // }, [isLoading]);

  useEffect(() => {
  if (isEdit) {
    setSingleSlotCapacity(data?.totalSlots || "");
  }
}, [isEdit, data?.totalSlots]);

  useEffect(() => {
    if (!isEdit) {
      setImageName([]);
      setUploadedFiles([]);
      setIdToDelete([]);
      // setTimeSlots([
      //   {
      //     startDate: null,
      //     endDate: null,
      //     startTime: null,
      //     endTime: null,
      //     allslots: "",
      //   },
      // ]);
    }

    setOpenToaster(false);
  }, [resetForm]);
  useEffect(() => {
    if (data?.eventSlots && data.eventSlots.length > 0) {
      setTimeSlots(data.eventSlots);
    }
  }, [data.eventSlots]);

  const handlePublish = (e: any) => {
    if (!validateBeforeSubmit()) return;
    const payload = preparePayload(data, timeSlots);
    console.log("FINAL PAYLOAD:", payload);
    submitForm(e, payload, uploadedFiles, idToDelete, timeSlots);
  };

  const preparePayload = (data: any, timeSlots: TimeSlot[]) => {
    const slotsToUse =
      timeSlots.length > 0
        ? timeSlots
        : [
            {
              startDate: data.eventStartDate,
              endDate: data.eventEndDate,
              startTime: data.eventStartTime,
              endTime: data.eventEndTime,
              allslots: isEdit ? data?.totalSlots : singleSlotCapacity,
            },
          ];

    const eventSlots = slotsToUse.map((slot) => ({
      transport: true,
      totalVolunteers: Number(slot.allslots) || 0,
      userRegistered: 0,
      eventSlotStartDate: slot.startDate,
      eventSlotStartTime: slot.startTime,
      eventSlotEndDate: slot.endDate,
      eventSlotEndTime: slot.endTime,
      totalSlots: Number(slot.allslots),
      allslots: Number(slot.allslots),
    }));

    const totalSlotsValue =
    slotsToUse.length === 1
      ? Number(slotsToUse[0].allslots || 0)
      : slotsToUse.reduce(
          (sum, s) => sum + Number(s.allslots || 0),
          0,
        );
    const { timeSlots: _removed, ...cleanData } = data;
    return {
      ...cleanData,
      imageName: Array.isArray(data.imageName)
        ? data.imageName[0]
        : data.imageName,
      eventSlots,
      allslots: String(totalSlotsValue),
      totalSlots: String(totalSlotsValue),
    };
  };

  const eventImages = data?.eventImages ?? [];
  const handleUploadClick = async (e: any) => {
    let images: Array<File> = e.target.files;
    let files = Array.from(images);
    const compressedFilesPromises = files.map((file) => compressImage(file));
    const compressedFiles: any = await Promise.all(compressedFilesPromises);
    handleFile(compressedFiles);
  };

  const compressImage = (file: File): Promise<File> => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6,
        width: 1024,
        height: 1024,
        convertTypes: ["image/jpeg"],
        success(result: any) {
          resolve(new File([result], file.name, { type: result.type }));
        },
        error(err) {},
      });
    });
  };
  useEffect(() => {}, [data]);
  const handleFile = (files: File[]) => {
    if (!files || files.length === 0) return;
    const formattedFiles = files.map((file) => ({
      file,
      name: file.name,
    }));

    const filtered = formattedFiles.filter(
      (f) => !imageName.some((img: any) => img.name === f.name),
    );
    setImageName((prev: any) => [...prev, ...filtered]);
    setUploadedFiles((prev) => [...prev, ...files]);
    handleChange((prev: any) => ({
      ...prev,
      imageName: filtered.map((f) => f.name),
    }));
  };

  const changeDateFormat = (date: Dayjs | null) =>
    dayjs(date).format("YYYY-MM-DD");
  const changeTimeFormat = (time: Dayjs | null) =>
    dayjs(time).format("HH:mm:ss");
  const handleFormChange = (e: any, keyName?: string) => {
    let name;
    let value;

    if (e?.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = keyName;
      value = e;
    }
    if (name === "eventCategory") {
      value = { id: value };
    }

    if (name === "allGoals") {
      value = typeof value === "string" ? value.split(",") : value;
    }

    handleChange((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSlotsChange = (value: string) => {
    if (title.includes("Create")) {
      handleChange((prev: any) => ({
        ...prev,
        totalSlots: value,
      }));
      return;
    }

    if (title === "Update Event") {
      const slotData = {
        id: data?.id,
        allslots: value,
      };

      if (parseInt(value) > getEvent.allslots) {
        dispatch(allSlots(slotData)).then((res: any) => {
          if (res.meta.requestStatus === "fulfilled") {
            handleChange((prev: any) => ({
              ...prev,
              totalSlots: res?.payload?.availableslots,
            }));
          } else {
            showError("Slots must be greater than existing slots");
          }
        });
      } else {
        showError("Slots must be greater than existing slots");
      }
    }
  };

  const showError = (msg: string) => {
    setToastMessage(msg);
    setOpenToaster(true);
  };

  const handleTimeSlotChange = (
    index: number,
    field: keyof TimeSlot,
    value: any,
  ) => {
    setTimeSlots((prev) =>
      prev.map((slot, i) => (i === index ? { ...slot, [field]: value } : slot)),
    );
  };

  const handleAddTimeSlot = () => {
    setTimeSlots((prev) => [
      ...prev,
      {
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        allslots: "",
      },
    ]);
  };

  const handleDeleteTimeSlot = (index: number) => {
    setTimeSlots((prev) => prev.filter((_, i) => i !== index));
  };

  const getImageName = (imageName: string) => {
    if (imageName?.includes("?")) {
      let name = imageName.split("?")[0].split("/");
      let img = name[name.length - 1];
      return img;
    } else return imageName;
  };

  const getIdByImage = (image: string) => {
    const event = eventImages.find((event: any) => event.imageName === image);
    return event?.id ?? null;
  };

  const deleteImage = (e: any, imageToDelete: string) => {
    e.preventDefault();
    const updated = imageName.filter((img: any) => img.name !== imageToDelete);
    if (title === "Update Event") {
      const id = getIdByImage(imageToDelete);
      if (id) {
        setIdToDelete((prev: any[]) => [...prev, id]);
      }
    }
    setImageName(updated);
    setUploadedFiles((prev) => prev.filter((file) => file.name !== imageToDelete));
    handleChange((prev: any) => ({
      ...prev,
      imageName: updated.map((img: any) => img.name),
    }));
  };

  useEffect(() => {
    dispatch(fetchEventCategories());
    dispatch(getAllDepartments());
  }, []);

  useEffect(() => {
    if (eventImages.length) {
      const imageData = eventImages.map((item: any) => ({
        ...item,
        name: getImageName(item.imageName),
      }));
      setImageName(imageData);
    }
  }, [eventImages]);

  const handleQuillEdit = (value: any) => {
    handleChange((prev: any) => ({
      ...prev,
      description: value,
    }));
  };
  const defaultQuillStyle = {
    height: "100px",
    width: "100%",
    backgroundSize: "auto 100%",
    backgroundRepeat: "no-repeat",
  };
  const emptyQuillStyle = {
    borderLeft: "1px solid red",
    borderRight: "1px solid red",
    borderBottom: "1px solid red",
  };

  const validateSlot = (
    slot: any,
    index: number,
    slots: any[],
    formData: any,
  ) => {
    const row = `Slot ${index + 1}`;
    if (!slot.startDate || !slot.startTime || !slot.endDate || !slot.endTime) {
      return `${row}: Please fill all slot fields`;
    }

    const start = dayjs(`${slot.startDate} ${slot.startTime}`);
    const end = dayjs(`${slot.endDate} ${slot.endTime}`);

    const eventStart = dayjs(
      `${formData?.eventStartDate} ${formData?.eventStartTime}`,
    );
    const eventEnd = dayjs(
      `${formData?.eventEndDate} ${formData?.eventEndTime}`,
    );

    if (!start.isValid() || !end.isValid()) {
      return `${row}: Invalid date/time`;
    }

    // End vs Start (date first, then time)
    if (slot.endDate < slot.startDate) {
      return `${row}: Slot end date must be after slot start date`;
    }

    if (slot.endDate === slot.startDate && !end.isAfter(start)) {
      return `${row}: Slot end time must be after slot start time`;
    }

    //  Event Start comparison
    if (slot.startDate < formData.eventStartDate) {
      return `${row}: Slot start date must be after Event start date`;
    }

    if (
      slot.startDate === formData.eventStartDate &&
      start.isBefore(eventStart)
    ) {
      return `${row}: Slot start time must be after Event start time`;
    }

    //  Event End comparison
    if (slot.endDate > formData.eventEndDate) {
      return `${row}: Slot end date must be before Event end date`;
    }

    if (slot.endDate === formData.eventEndDate && end.isAfter(eventEnd)) {
      return `${row}: Slot end time must be before Event end time`;
    }

    //  Capacity
    if (!slot.allslots || isNaN(slot.allslots) || Number(slot.allslots) <= 0) {
      return `${row}: Enter valid capacity`;
    }

    //  Previous slot
    if (index > 0) {
      const prev = slots[index - 1];

      if (slot.startDate < prev.endDate) {
        return `${row}: Slot start date must be after previous slot end date`;
      }

      if (
        slot.startDate === prev.endDate &&
        !dayjs(`${slot.startDate} ${slot.startTime}`).isAfter(
          dayjs(`${prev.endDate} ${prev.endTime}`),
        )
      ) {
        return `${row}: Slot start time must be after previous slot end time`;
      }
    }

    return null;
  };
  const validateAllSlots = () => {
    for (let i = 0; i < timeSlots.length; i++) {
      const error = validateSlot(timeSlots[i], i, timeSlots, data);

      if (error) {
        setOpenToaster(true);
        setToastMessage(error);
        return false;
      }
    }
    return true;
  };

  const validateBeforeSubmit = () => {
    if (
      !data?.eventStartDate ||
      !data?.eventEndDate ||
      !data?.eventStartTime ||
      !data?.eventEndTime
    ) {
      setOpenToaster(true);
      setToastMessage("Please fill Event Start & End Date/Time first");
    //  setToastMessage("All fields are mandatory");
      return false;
    }
    if (
      timeSlots.length === 0 &&
      (!singleSlotCapacity ||
        isNaN(Number(singleSlotCapacity)) ||
        Number(singleSlotCapacity) <= 0)
    ) {
      setOpenToaster(true);
      setToastMessage("All fields are mandatory");
      return false;
    }
    return validateAllSlots();
  };

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 6 }}>
        <Typography
          variant="h5"
          sx={{ mb: 3, fontWeight: 400, fontSize: "45px" }}
        >
          {title}
        </Typography>

        <Typography
          variant="h5"
          sx={{ mb: 3, fontWeight: 700, fontSize: "22px" }}
        >
          Event Information
        </Typography>

        <Box component="form" noValidate>
          <Grid container spacing={2}>
            <Grid size={{ xs: 6 }}>
              <FormControl variant="standard" fullWidth required>
                <BoldDemoItem label={"Event Name"}>
                  <OutlinedInput
                    name="title"
                    placeholder="Event Name"
                    size="small"
                    value={data?.title}
                    sx={
                      openToasterForm && data?.title == ""
                        ? {
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "red",
                            },
                          }
                        : {}
                    }
                    onChange={(e) => handleFormChange(e)}
                  />
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label={"Location"}>
                  <NativeSelect
                    name="location"
                    value={data?.location || ""}
                    onChange={(e) => handleFormChange(e)}
                    input={<OutlinedInput />}
                    size="small"
                    sx={{
                      color: data?.location ? "#000" : "rgb(170, 170, 170)",

                      ...(openToasterForm &&
                      (data?.location === "" ||
                        data?.location === "Select Location")
                        ? {
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "red",
                            },
                          }
                        : {}),
                    }}
                  >
                    <option value="">Select Location</option>

                    {location.map((lc, index) => (
                      <option key={index} value={lc} style={{ color: "#000000" }}>
                        {lc}
                      </option>
                    ))}
                  </NativeSelect>
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth required>
                <BoldDemoItem label="Venue">
                  <OutlinedInput
                    name="venue"
                    value={data?.venue}
                    sx={
                      openToasterForm && data?.venue == ""
                        ? {
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "red",
                            },
                          }
                        : {}
                    }
                    placeholder={
                      data?.location == "Virtual"
                        ? "Meeting link"
                        : "Event Venue"
                    }
                    id="bootstrap-input"
                    size="small"
                    onChange={(e) => handleFormChange(e)}
                  />
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Department">
                  <NativeSelect
                    name="dept"
                    value={data?.dept || ""}
                    onChange={(e) => handleFormChange(e)}
                    input={<OutlinedInput />}
                    size="small"
                    sx={{
                      color: data?.dept ? "#000" : "rgb(170, 170, 170)",

                      ...(openToasterForm && !data?.dept
                        ? {
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "red",
                            },
                          }
                        : {}),
                    }}
                  >
                    <option value="">Select Department</option>

                    {departments.map((dep, index) => (
                      <option key={index} value={dep} style={{ color: "#000000" }}>
                        {dep}
                      </option>
                    ))}
                  </NativeSelect>
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Event Category">
                  <NativeSelect
                    name="eventCategory"
                    value={data?.eventCategory?.id || ""}
                    onChange={(e) => handleFormChange(e)}
                    input={<OutlinedInput />}
                    size="small"
                    sx={{
                      color: data?.eventCategory?.id
                        ? "#000"
                        : "rgb(170, 170, 170)",

                      ...(openToasterForm && data?.eventCategory?.id == ""
                        ? {
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "red",
                            },
                          }
                        : {}),
                    }}
                  >
                    <option value="">Select Category</option>
                    {eventCategories.map((ec: any, index: number) => {
                      return (
                        <option key={index} value={ec.id} style={{ color: "#000000" }}>
                          {ec.name}
                        </option>
                      );
                    })}
                  </NativeSelect>
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Event Goals">
                  <Select
                    multiple
                    name="allGoals"
                    value={data?.allGoals || []}
                    onChange={(e) => handleFormChange(e)}
                    input={<OutlinedInput label="Event Goals" />}
                    displayEmpty
                    size="small"
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return (
                          <span style={{ color: "rgb(170, 170, 170)" }}>
                            Select goals
                          </span>
                        );
                      }
                      return selected.join(", ");
                    }}
                    sx={{
                      ...(openToasterForm &&
                      (!data?.allGoals || data?.allGoals.length === 0)
                        ? {
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "red",
                            },
                          }
                        : {}),
                    }}
                    MenuProps={{ disablePortal: true }}
                  >
                    <MenuItem disabled value="">
                      <em>Select goals</em>
                    </MenuItem>

                    {options.map((name) => (
                      <MenuItem key={name} value={name}>
                        <ListItemText primary={name} />
                        <Checkbox checked={data?.allGoals?.includes(name)} />
                      </MenuItem>
                    ))}
                  </Select>
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Contact Person">
                  <OutlinedInput
                    name="contact"
                    placeholder="Email Address"
                    required
                    size="small"
                    value={data?.contact}
                    sx={
                      openToasterForm && data?.contact == ""
                        ? {
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "red",
                            },
                          }
                        : {}
                    }
                    onChange={(e) => handleFormChange(e)}
                  />
                </BoldDemoItem>
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Divider
                sx={{
                  mb: 0,
                  borderColor: "#c4c4c4",
                  borderBottomWidth: 1,
                }}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  fontSize: "18px",
                }}
              >
                Date & Time
              </Typography>
            </Grid>

            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Event Start Date">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      name="eventStartDate"
                      format="DD/MM/YYYY"
                      disablePast
                      value={
                        data?.eventStartDate &&
                        data.eventStartDate !== "Invalid Date"
                          ? dayjs(data.eventStartDate)
                          : null
                      }
                      // value={data?.eventStartDate ? dayjs(data.eventStartDate) : null}
                      sx={
                        openToasterForm && !data?.eventStartDate
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(newValue) =>
                        handleFormChange(
                          changeDateFormat(newValue),
                          "eventStartDate",
                        )
                      }
                      slotProps={{
                        textField: { size: "small", error: false },
                        popper: { style: { zIndex: 9999 } },
                      }}
                    />
                  </LocalizationProvider>
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Event Start Time">
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="en"
                  >
                    <TimePicker
                      name="eventStartTime"
                      aria-placeholder="HH:MM AA"
                      //  value={dayjs(data?.eventStartTime, "HH:mm:ss")}

                      value={
                        data?.eventStartTime
                          ? dayjs(data.eventStartTime, "HH:mm:ss")
                          : null
                      }
                      sx={
                        openToasterForm && !data?.eventStartTime
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(newValue) =>
                        handleFormChange(
                          changeTimeFormat(newValue),
                          "eventStartTime",
                        )
                      }
                      slotProps={{
                        textField: {
                          size: "small",
                          error: false,
                          inputProps: { ["placeholder"]: "anything" },
                        },
                        popper: { style: { zIndex: 9999 } },
                      }}
                    />
                  </LocalizationProvider>
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Event End Date">
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="en-gb"
                  >
                    <DatePicker
                      format="DD/MM/YYYY"
                      name="eventEndDate"
                      // value={dayjs(data?.eventEndDate)}
                      value={
                        data?.eventEndDate ? dayjs(data.eventEndDate) : null
                      }
                      disablePast
                      sx={
                        openToasterForm && !data?.eventEndDate
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(newValue) =>
                        handleFormChange(
                          changeDateFormat(newValue),
                          "eventEndDate",
                        )
                      }
                      slotProps={{
                        textField: {
                          size: "small",
                          error: false,
                          placeholder: "DD/MM/YYYY",
                        },
                        popper: { style: { zIndex: 9999 } },
                      }}
                    />
                  </LocalizationProvider>
                </BoldDemoItem>
              </FormControl>
            </Grid>

            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Event End Time">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      name="eventEndTime"
                      // value={dayjs(data?.eventEndTime, "HH:mm:ss")}
                      value={
                        data?.eventEndTime
                          ? dayjs(data.eventEndTime, "HH:mm:ss")
                          : null
                      }
                      sx={
                        openToasterForm && !data?.eventEndTime
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(newValue) =>
                        handleFormChange(
                          changeTimeFormat(newValue),
                          "eventEndTime",
                        )
                      }
                      slotProps={{
                        textField: { size: "small", error: false },
                        popper: { style: { zIndex: 9999 } },
                      }}
                    />
                  </LocalizationProvider>
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Divider
                sx={{
                  mb: 0,
                  borderColor: "#c4c4c4",
                  borderBottomWidth: 1,
                }}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  fontSize: "18px",
                }}
              >
                Registration Period
              </Typography>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Registration Start Date">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      name="registrationStartDate"
                      format="DD/MM/YYYY"
                      //    value={dayjs(data?.registrationStartDate)}
                      value={
                        data?.registrationStartDate
                          ? dayjs(data.registrationStartDate)
                          : null
                      }
                      disablePast
                      sx={
                        openToasterForm &&
                        data?.registrationStartDate.$d == "Invalid Date"
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(newValue) =>
                        handleFormChange(
                          changeDateFormat(newValue),
                          "registrationStartDate",
                        )
                      }
                      slotProps={{
                        textField: { size: "small", error: false },
                        popper: { style: { zIndex: 9999 } },
                      }}
                    />
                  </LocalizationProvider>
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Registration Start Time">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      name="registrationStartTime"
                      //    value={dayjs(data?.registrationStartTime, "HH:mm:ss")}

                      value={
                        data?.registrationStartTime
                          ? dayjs(data.registrationStartTime, "HH:mm:ss")
                          : null
                      }
                      sx={
                        openToasterForm &&
                        data?.registrationStartTime.$d == "Invalid Date"
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(newValue) =>
                        handleFormChange(
                          changeTimeFormat(newValue),
                          "registrationStartTime",
                        )
                      }
                      slotProps={{
                        textField: { size: "small", error: false },
                        popper: { style: { zIndex: 9999 } },
                      }}
                    />
                  </LocalizationProvider>
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Registration End Date">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      name="registrationEndDate"
                      format="DD/MM/YYYY"
                      // value={dayjs(data?.registrationEndDate)}
                      value={
                        data?.registrationEndDate
                          ? dayjs(data.registrationEndDate)
                          : null
                      }
                      disablePast
                      sx={
                        openToasterForm &&
                        data?.registrationEndDate.$d == "Invalid Date"
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(newValue) =>
                        handleFormChange(
                          changeDateFormat(newValue),
                          "registrationEndDate",
                        )
                      }
                      slotProps={{
                        textField: { size: "small", error: false },
                        popper: { style: { zIndex: 9999 } },
                      }}
                    />
                  </LocalizationProvider>
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Registration End Time">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      name="registrationEndTime"
                      //  value={dayjs(data?.registrationEndTime, "HH:mm:ss")}
                      value={
                        data?.registrationEndTime
                          ? dayjs(data.registrationEndTime, "HH:mm:ss")
                          : null
                      }
                      sx={
                        openToasterForm &&
                        data?.registrationEndTime.$d == "Invalid Date"
                          ? {
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "red",
                              },
                            }
                          : {}
                      }
                      onChange={(newValue) =>
                        handleFormChange(
                          changeTimeFormat(newValue),
                          "registrationEndTime",
                        )
                      }
                      slotProps={{
                        textField: { size: "small", error: false },
                        popper: { style: { zIndex: 9999 } },
                      }}
                    />
                  </LocalizationProvider>
                </BoldDemoItem>
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Divider
                sx={{
                  mb: 0,
                  borderColor: "#c4c4c4",
                  borderBottomWidth: 1,
                }}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  fontSize: "18px",
                }}
              >
                Time Slots & Capacity
              </Typography>
            </Grid>

            {/* Right Side - Button */}
            <Grid
              size={{ xs: 6 }}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="outlined"
                onClick={handleAddTimeSlot}
                sx={{
                  textTransform: "capitalize",
                  borderColor: "#1B76D3",
                  color: "#1B76D3",
                  fontSize: "14px",
                  fontWeight: "700",
                  "&:hover": {
                    borderColor: "#1B76D3",
                    backgroundColor: "rgba(27,118,211,0.08)",
                  },
                }}
              >
                + Add Time Slot
              </Button>
            </Grid>

            {timeSlots.length === 0 && (
              <Grid container spacing={2} sx={{ mt: 2 }} alignItems="flex-end">
                <Grid size={{ xs: 12, md: 4 }}>
                  <FormControl variant="standard" fullWidth>
                    <BoldDemoItem label="Available Capacity">
                      <OutlinedInput
                        placeholder="Enter Capacity"
                        size="small"
                        fullWidth
                        value={
                          isEdit ? data?.totalSlots || "" : singleSlotCapacity
                        }
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          setSingleSlotCapacity(value);
                          handleChange((prev: any) => ({
                            ...prev,
                            totalSlots: value,
                          }));
                        }}
                      />
                    </BoldDemoItem>
                  </FormControl>
                </Grid>
                <Grid size={{ xs: 12, md: 8 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: "13px",
                      fontFamily: "mbcorpos !important",
                      color: "#616161",
                    }}
                  >
                    *To create different time slots for this event, please add a
                    slot.
                  </Typography>
                </Grid>
              </Grid>
            )}

            {timeSlots.map((slot, index) => (
              <Grid container spacing={2} key={index} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 2.4 }}>
                  <FormControl variant="standard" fullWidth>
                    <BoldDemoItem label=" Start Date">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          format="DD/MM/YYYY"
                          value={slot.startDate ? dayjs(slot.startDate) : null}
                          disablePast
                          onChange={(newValue) =>
                            handleTimeSlotChange(
                              index,
                              "startDate",
                              changeDateFormat(newValue),
                            )
                          }
                          slotProps={{
                            textField: { size: "small", fullWidth: true },
                            popper: { style: { zIndex: 9999 } },
                          }}
                        />
                      </LocalizationProvider>
                    </BoldDemoItem>
                  </FormControl>
                </Grid>

                <Grid size={{ xs: 12, md: 2.4 }}>
                  <FormControl variant="standard" fullWidth>
                    <BoldDemoItem label="End Date">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          format="DD/MM/YYYY"
                          value={slot.endDate ? dayjs(slot.endDate) : null}
                          disablePast
                          onChange={(newValue) =>
                            handleTimeSlotChange(
                              index,
                              "endDate",
                              changeDateFormat(newValue),
                            )
                          }
                          slotProps={{
                            textField: { size: "small", fullWidth: true },
                            popper: { style: { zIndex: 9999 } },
                          }}
                        />
                      </LocalizationProvider>
                    </BoldDemoItem>
                  </FormControl>
                </Grid>

                <Grid size={{ xs: 12, md: 2.4 }}>
                  <FormControl variant="standard" fullWidth>
                    <BoldDemoItem label="Start Time">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          value={
                            slot.startTime
                              ? dayjs(slot.startTime, "HH:mm:ss")
                              : null
                          }
                          onChange={(newValue) =>
                            handleTimeSlotChange(
                              index,
                              "startTime",
                              changeTimeFormat(newValue),
                            )
                          }
                          slotProps={{
                            textField: { size: "small", fullWidth: true },
                          }}
                        />
                      </LocalizationProvider>
                    </BoldDemoItem>
                  </FormControl>
                </Grid>

                <Grid size={{ xs: 12, md: 2.4 }}>
                  <FormControl variant="standard" fullWidth>
                    <BoldDemoItem label="End Time">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          value={
                            slot.endTime
                              ? dayjs(slot.endTime, "HH:mm:ss")
                              : null
                          }
                          onChange={(newValue) =>
                            handleTimeSlotChange(
                              index,
                              "endTime",
                              changeTimeFormat(newValue),
                            )
                          }
                          slotProps={{
                            textField: { size: "small", fullWidth: true },
                          }}
                        />
                      </LocalizationProvider>
                    </BoldDemoItem>
                  </FormControl>
                </Grid>

                <Grid
                  size={{ xs: 12, md: 2.4 }}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <FormControl variant="standard" fullWidth>
                    <BoldDemoItem label="Available Capacity">
                      <OutlinedInput
                        placeholder="Enter Capacity"
                        size="small"
                        fullWidth
                        value={slot.allslots}
                        onChange={(e) =>
                          handleTimeSlotChange(
                            index,
                            "allslots",
                            e.target.value.replace(/[^0-9]/g, ""),
                          )
                        }
                        sx={{ mr: 1 }}
                      />
                    </BoldDemoItem>
                  </FormControl>
                  {timeSlots.length > 1 && (
                    <IconButton
                      sx={{ marginTop: "20px" }}
                      onClick={() => handleDeleteTimeSlot(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            ))}

            {title == "Update Event" && (
              <Grid size={{ xs: 3 }}>
                <FormControl variant="standard" fullWidth>
                  <BoldDemoItem label="Slots Available">
                    <OutlinedInput
                      name="totalSlots"
                      disabled
                      placeholder="No. of Slots"
                      id="bootstrap-input"
                      size="small"
                      value={data?.totalSlots}
                      onChange={(e) => handleFormChange(e)}
                    />
                  </BoldDemoItem>
                </FormControl>
              </Grid>
            )}

            <Grid size={{ xs: 12 }}>
              <Divider
                sx={{
                  mb: 0,
                  borderColor: "#c4c4c4",
                  borderBottomWidth: 1,
                }}
              />
            </Grid>
            <Grid size={{ xs: 3 }}></Grid>
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  fontSize: "18px",
                }}
              >
                Description & Media
              </Typography>
            </Grid>

            <Grid size={{ xs: 9 }}>
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Description">
                  <ReactQuill
                    value={data?.description}
                    onChange={handleQuillEdit}
                    placeholder="Event Description"
                    style={
                      openToasterForm &&
                      data?.description.replace(/<(.|\n)*?>/g, "").trim()
                        .length === 0
                        ? emptyQuillStyle
                        : defaultQuillStyle
                    }
                    modules={{
                      toolbar: {
                        container: [
                          ["bold", "italic", "underline", "strike"],

                          [
                            {
                              list: "ordered",
                            },
                            {
                              list: "bullet",
                            },
                          ],

                          [{ align: [] }],

                          ["clean"],

                          [{ color: [] }, { background: [] }],
                        ],
                      },
                    }}
                  />
                </BoldDemoItem>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 3 }} direction="column">
              <FormControl variant="standard" fullWidth>
                <BoldDemoItem label="Event Banners:">
                  <Typography variant="caption" fontSize="11px">
                    Max. 5 Banners
                  </Typography>
                  <Button
                    component="label"
                    role={undefined}
                    disabled={imageName.length >= 5}
                    variant="outlined"
                    tabIndex={-1}
                    sx={{ textTransform: "capitalize" }}
                    className="upload-button"
                  >
                    Upload Photo
                    <VisuallyHiddenInput
                      type="file"
                      accept="image/*"
                      multiple={true}
                      onChange={(e: any) => handleUploadClick(e)}
                    />
                  </Button>
                </BoldDemoItem>
              </FormControl>
              {imageName.length > 0 && (
                <Box
                  sx={{
                    display: "grid",
                    marginTop: "10px",
                  }}
                  gap={1}
                >
                  {imageName.map((image: any, index: number) => {
                    return (
                      <OutlinedInput
                        key={index}
                        size="small"
                        value={image.name}
                        className="image-name-style"
                        sx={{ color: "primary" }}
                        endAdornment={
                          <InputAdornment position="end">
                            <DeleteOutlinedIcon
                              fontSize="small"
                              color="primary"
                              sx={{ cursor: "pointer" }}
                              onClick={(e) => deleteImage(e, image.name)}
                            />
                          </InputAdornment>
                        }
                      />
                    );
                  })}
                </Box>
              )}
            </Grid>
            <Grid>
              <Grid
                size={{ xs: 12 }}
                sx={{
                  mt: 5,
                  textAlign: "center",
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    textTransform: "capitalize",
                    minWidth: "200px",
                    borderWidth: "4px"
                  }}
                  onClick={handlePublish}
                  className="mui-modal-button"
                  disabled={disablePublish}
                >
                  {isEdit ? "Update Event" : "Publish Event"}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* {isLoading  && (
            <div
              style={{
                position: "absolute",
                top: "0%",
                left: "0%",
                bottom: "0%",
                width: "100%",
                height: "200%",
                backgroundColor: "rgba(0, 0, 0, 0.7)", 
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px", 
                zIndex: "10000000", 
              }}
            >
           
              <Loader />
            </div>
          )} */}
      <Toaster
        openToaster={openToaster}
        toastMessage={toastMessage}
        handleToasterClose={() => setOpenToaster(false)}
      />
    </>
  );
};

export default ManageEventForm;
